<template>
	<b-modal
		:visible="show"
		@hide="() => this.$emit('close')"
		hide-footer
		:title="'Change birthday' | translate"
	>
		<form action="." method="post" class="text-center">
			<Datepicker :format="format" v-model="birthday" />
			<button class="btn btn-primary" @click.prevent="changeBirthday">
				{{ 'Confirm' | translate }}
			</button>
			<button class="btn btn-secondary" @click.prevent="$emit('close')">
				{{ 'Cancel' | translate }}
			</button>
		</form>
	</b-modal>
</template>

<script>
import Datepicker from 'vuejs-datepicker'

export default {
	name: 'modal-birthday',
	data() {
		return {
			format: 'dd.MM.yyyy',
			birthday: null,
		}
	},
	props: ['show'],
	created() {
		this.birthday =
			this.$store.state.myProfile.birthday === null
				? null
				: this.$store.state.myProfile.birthday
	},
	components: {
		Datepicker,
	},
	methods: {
		changeBirthday() {
			if (this.birthday.length !== 10) {
				let birthday = this.birthday.toISOString().slice(0, 10)
				this.axios({
					method: 'patch',
					url: `users/user/${this.$store.state.myProfile.id}`,
					data: {
						birthday: birthday,
					},
				}).then(response => {
					this.$toast(this.$t('Changes saved'), {
						className: ['btn-success', 'notif'],
						duration: 3000,
					})
					let myProfile = this.$store.state.myProfile
					myProfile.birthday =
						birthday.slice(8, 10) +
						'.' +
						birthday.slice(5, 7) +
						'.' +
						birthday.slice(0, 4)
					window.localStorage.setItem('userProfile', JSON.stringify(myProfile))
					this.$emit('close')
				})
			} else {
				this.$toast(this.$t('Changes saved'), {
					className: ['btn-success', 'notif'],
					duration: 3000,
				})
				this.$emit('close')
			}
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
button {
	margin: 10px;
}
</style>
